import React, { useState, Component } from 'react';
import { motion } from 'framer-motion';
import { MailIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function ContactPage() {
  const {
    t
  } = useLanguage();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const subject = encodeURIComponent(`Contact from ${formData.name}`);
    const body = encodeURIComponent(`Name: ${formData.name}\nEmail: ${formData.email}\n\n${formData.message}`);
    window.location.href = `mailto:${t.contact.email}?subject=${subject}&body=${body}`;
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <div className="max-w-6xl mx-auto px-4 md:px-6 py-8 md:py-12" data-id="element-88">
      <motion.h1 initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="text-3xl md:text-5xl font-bold mb-8 text-center text-[#2A4B7C]" data-id="element-89">
        {t.contact.title}
      </motion.h1>
      <p className="text-center text-gray-600 mb-8 md:mb-12 text-lg" data-id="element-90">
        {t.contact.intro}
      </p>

      <div className="grid md:grid-cols-2 gap-6 md:gap-12" data-id="element-91">
        {/* Contact Info */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} className="bg-white rounded-lg shadow-md p-6 md:p-8" data-id="element-92">
          <h2 className="text-2xl font-semibold mb-6 text-[#2A4B7C]" data-id="element-93">
            Get in Touch
          </h2>

          <div className="space-y-6" data-id="element-94">
            <div className="flex items-start gap-4" data-id="element-95">
              <MailIcon className="text-[#1B2A4A] mt-1 flex-shrink-0" size={24} data-id="element-96" />
              <div className="min-w-0" data-id="element-97">
                <h3 className="font-semibold mb-1 text-[#111827]" data-id="element-98">
                  {t.contact.emailLabel}
                </h3>
                <a href={`mailto:${t.contact.email}`} className="text-[#1B2A4A] hover:text-amber-600 transition-colors break-all" data-id="element-99">
                  {'reference.studentjournal@gmail.com\n'}
                </a>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Contact Form */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} className="bg-white rounded-lg shadow-md p-6 md:p-8" data-id="element-100">
          <h2 className="text-2xl font-semibold mb-6 text-[#2A4B7C]" data-id="element-101">
            {t.contact.formTitle}
          </h2>

          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-102">
            <div data-id="element-103">
              <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-104">
                {t.contact.nameLabel}
              </label>
              <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} placeholder={t.contact.namePlaceholder} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#1B2A4A] focus:border-transparent outline-none" data-id="element-105" />
            </div>

            <div data-id="element-106">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-107">
                Email
              </label>
              <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} placeholder={t.contact.emailPlaceholder} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#1B2A4A] focus:border-transparent outline-none" data-id="element-108" />
            </div>

            <div data-id="element-109">
              <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-110">
                {t.contact.messageLabel}
              </label>
              <textarea id="message" name="message" value={formData.message} onChange={handleChange} placeholder={t.contact.messagePlaceholder} required rows={5} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#1B2A4A] focus:border-transparent outline-none resize-none" data-id="element-111" />
            </div>

            <button type="submit" className="w-full text-white px-6 py-3 rounded-md hover:bg-[#2a3a5a] transition-colors font-medium bg-[#2A4B7C]" data-id="element-112">
              {t.contact.sendButton}
            </button>
          </form>
        </motion.div>
      </div>
    </div>;
}